<template lang="pug">
  .save-form
    form.panel.panel-default(role="form" @submit.prevent="onSubmit")
      .panel-heading.panel-title(v-if="headerTitle") {{ headerTitle }}
      .panel-body
        .form-horizontal
          slot
      .panel-footer
        .text-right
          SspActionButton(type="submit" :icon="icon" :title="title" :spinning="saving" :disabled="saveDisabled || saving")
          a.btn.btn-default.ml10(v-if="hasCancel" type="button" @click="cancel") Cancel
</template>

<script>
import SspActionButton from './SspActionButton'

export default {
  props: {
    icon: {
      type: String,
      required: false
    },
    saveDisabled: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    hasCancel: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'Save'
    },
    headerTitle: {
      type: String,
      default: null
    }
  },
  data: () => ({
    resolving: false
  }),
  methods: {
    onSubmit(event) {
      this.$emit('onSubmit', event)
    },
    cancel() {
      this.$router.go(-1)
    }
  },
  components: {
    SspActionButton
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/SspSaveForm.vue